import * as XLSX from 'xlsx';

/**
 * Функция экспортирует данные в xlsx
 * @param {Record<string, string | number | undefined>[]} data - данные для экспорта
 * @param {string} title - название для экспортируемого файла
 * @param {string[][]} headers - названия столбцов (опционально, если не переданы, то названиями столбцов будут названия свойств объекта)
 * @param {string} sheetTitle - название листов (опционально, дефолтное название - 'Лист1')
 */
export const exportInXlsx = (
  data: Record<string, string | number | undefined>[],
  title: string,
  headers?: string[][],
  sheetTitle = 'Лист 1',
) => {
  const worksheet = XLSX.utils.json_to_sheet(data);

  if (headers) {
    XLSX.utils.sheet_add_aoa(worksheet, headers, { origin: 'A1' });
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetTitle);

  const colWidths = Object.keys(data[0]).map((key) => {
    const maxLength = Math.max(...data.map((row) => (row[key] ? String(row[key]).length : 0)), 0);
    return { wch: maxLength + 2 };
  });

  worksheet['!cols'] = colWidths;

  XLSX.writeFile(workbook, `${title}.xlsx`);
};
